import Decimal from 'decimal.js';

// Use decimal.js to sum an array of numbers exactly without floating-point
// drift; undefined/null values are treated as 0
const safeSum = (values: Array<number | null | undefined>) =>
  Decimal.sum(0, ...values.map((value) => value ?? 0)).toNumber();

export default safeSum;
